import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import toastHandler from 'Utils/toastHandler';
import { STAGES_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { ICreateStageRequest, IStage } from 'Data/interfaces/Obra/IObraStages';
import { useDispatch } from 'react-redux';
import { ActivitiesActions } from 'Store/Activities/Activities.actions';

export const useQueryCreateStages = () => {
  const dispatch = useDispatch();

  const { mutate, isPending } = useMutation({
    mutationFn: (variables: ICreateStageRequest) => {
      return ObrasApiV2.createStages(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await queryClient.cancelQueries({
        queryKey: [STAGES_QUERY_KEY, variables.constructionStieId],
      });

      queryClient.setQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionStieId],
        (oldData) => {
          if (oldData && oldData.length > 0) {
            if (data.data.IsDefault) {
              const currentDefaultIndex = oldData.findIndex((stage) => {
                return stage.IsDefault;
              });

              if (currentDefaultIndex !== -1) {
                oldData[currentDefaultIndex].IsDefault = false;
              }
            }
            return [...oldData, data.data];
          }
          return [data.data];
        },
      );
      dispatch(
        ActivitiesActions.createStagesSuccess({
          constructionStieId: variables.constructionStieId,
          stage: data.data,
        }),
      );

      toastHandler.showSuccess('Etapa criada com sucesso!');
    },
    onError: (error: any) => {
      const errorMsg = error.errors ? error.errors[0].Message : 'Erro ao criar Etapa!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    createStage: mutate,
    isLoading: isPending,
  };
};
